import React, { useEffect } from 'react';
import { KeyboardTypeOptions, StyleSheet, View } from 'react-native';
import { CodeField, Cursor, useBlurOnFulfill, useClearByFocusCell } from 'react-native-confirmation-code-field';

import Text from '@/components/Text';

const CELL_COUNT = 6;

interface Props {
  value: string | undefined;
  setValue: React.Dispatch<React.SetStateAction<string>>;
  keyboardType?: KeyboardTypeOptions;
}

const CodeInput = ({ value, setValue, keyboardType = 'number-pad' }: Props) => {
  const ref = useBlurOnFulfill({ value, cellCount: CELL_COUNT });
  const [props, getCellOnLayoutHandler] = useClearByFocusCell({
    value,
    setValue
  });

  useEffect(() => {
    ref.current?.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CodeField
      ref={ref}
      {...props}
      value={value}
      onChangeText={setValue}
      cellCount={CELL_COUNT}
      rootStyle={styles.codeFieldRoot}
      keyboardType={keyboardType}
      textContentType="oneTimeCode"
      renderCell={({ index, symbol, isFocused }) => (
        <Text key={index} style={styles.cell} onLayout={getCellOnLayoutHandler(index)}>
          {symbol ||
            (isFocused ? (
              <Cursor />
            ) : (
              <View style={styles.dotContainer}>
                <View style={styles.dot} />
              </View>
            ))}
        </Text>
      )}
    />
  );
};

export default CodeInput;

const styles = StyleSheet.create({
  codeFieldRoot: {
    width: '100%',
    justifyContent: 'center'
  },

  cell: {
    width: 50,
    height: 50,
    lineHeight: 58,
    fontSize: 38,
    textAlign: 'center',
    color: 'black'
  },

  dot: {
    height: 14,
    width: 14,
    borderRadius: 7,
    backgroundColor: '#777777'
  },

  dotContainer: {
    height: 50,
    width: 50,
    alignItems: 'center',
    justifyContent: 'center'
  }
});
